import { render, staticRenderFns } from "./OptionTargetOtherUserListModal.vue?vue&type=template&id=5563cb80&scoped=true&lang=pug"
import script from "./OptionTargetOtherUserListModal.vue?vue&type=script&lang=ts"
export * from "./OptionTargetOtherUserListModal.vue?vue&type=script&lang=ts"
import style0 from "./OptionTargetOtherUserListModal.vue?vue&type=style&index=0&id=5563cb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563cb80",
  null
  
)

export default component.exports